import { Trans, useI18n } from '@i18n';
import { Checkbox, FormControlLabel, FormGroup, Stack } from '@mui/material';
import { memo, useCallback } from 'react';
import InfoTooltip from '@/components/InfoTooltip';
import Collapsible from '../../common/Collapsible';
import { useBuildingFilters } from '../BuildingFiltersProvider';

function HasConsumptionData() {
  const { t } = useI18n();
  const { filters, setFilters } = useBuildingFilters();

  const handleToggle = useCallback(
    (value: boolean, isChecked: boolean) => {
      void setFilters((prev) => ({
        ...prev,
        hasConsumptionData: isChecked ? value : null,
      }));
    },
    [setFilters],
  );

  return (
    <Collapsible
      title={<Trans i18nKey="DataCollection_BuildingListFilter-hasConsumptionData" />}
      titleEndAdornment={
        <InfoTooltip
          text={t('DataCollection_BuildingListFilter-hasConsumptionDataTooltip')}
          sx={{ p: 0, svg: { height: 16, width: 16 } }}
        />
      }
    >
      <Stack spacing={1} mt={-1}>
        <FormGroup
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 1,
            width: '100%',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.hasConsumptionData === true}
                onChange={(e) => handleToggle(true, e.target.checked)}
              />
            }
            label={<Trans i18nKey="General_Yes" />}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.hasConsumptionData === false}
                onChange={(e) => handleToggle(false, e.target.checked)}
              />
            }
            label={<Trans i18nKey="General_No" />}
          />
        </FormGroup>
      </Stack>
    </Collapsible>
  );
}

export const HasConsumptionDataFilter = memo(HasConsumptionData);
